<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading
        :active.sync="isLoading"
        loader="spinner"
        color="#36304a"
        :width="70"
      ></loading> -->
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar
          class="formCard"
          style="border-radius: 5px !important; padding-left: 0px"
          toggleable="lg"
          type="dark"
          variant="primary"
        >
          <b-navbar-brand center>Freight Export Details New</b-navbar-brand>
        </b-navbar>

        <div class="mt-2">
          <h5 class="text-muted pull-right mt-2 ml-3">
            <small v-if="isLoading == false">{{ totalRows }} Entries</small>
          </h5>
        </div>
        <div class="cod-md-12">
          <div class="col-md-8">
            <b-form-group>
              <b-input-group>
                <b-form-input :formatter="capitalizeAll"
                  v-model="filter"
                  @input="debounceSearch"
                  placeholder="Type To Search  (Assignment No. / Client / Container No./SB No. Shipper Inv No.)"
                />
                <b-input-group-append>
                  <b-button :disabled="!filter" @click="filterClear"
                    >Clear</b-button
                  >
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </div>
          <div class="col-md-3">
            <model-list-select
              @input="viewFFExportFCL('0', '0', '1', '1')"
              :list="invoiceStatusList"
              v-model="billingFilter"
              option-value="inv"
              option-text="int"
              placeholder="Select Status"
            ></model-list-select>
          </div>
        </div>

        <!-- Main table element -->
        <div class="table-responsive tableMain">
          <b-table
            show-empty
            stacked="md"
            :items="FFExport"
            :fields="fields"
            :per-page="perPage"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
          >
            <template slot="isFFExportActive" slot-scope="row0">
              <span>{{ row0.index + 1 + (currentPage - 1) * perPage }}</span>
            </template>
            <template slot="ffExportFclSeries" slot-scope="row11">
              <div
                class="text-left"
                :style="
                  row11.item.seenExec == '0' ? 'color:red' : 'color:black'
                "
              >
                <!--  -->
                <div
                  :style="
                    row11.item.seenExec == '0' ? 'color:red' : 'color:black'
                  "
                  @click="viewExportFCLPage(row11.item)"
                  class="showMoreData"
                >
                  <b-badge v-if="row11.item.seenExec == '0'" variant="danger"
                    >New
                    <br />
                  </b-badge>

                  <span
                    ><b> {{ row11.item.ffExportFclSeries }}</b></span
                  >
                  <br />
                  <span>Created on : {{ row11.item.loginTime | moment }}</span>
                  <br />
                  <span> From : {{ row11.item.EmpLoc }}<br /></span>
                  <span>By : {{ row11.item.raisedBy }}</span>
                </div>

                <b-button
                  class="mt-2"
                  style="font-size: 0.675rem"
                  size="sm"
                  @click="showDocModal(row11.item)"
                  variant="outline-info"
                  >Summary & Documents</b-button
                >
              </div>
            </template>
            <template slot="freightContainerNo" slot-scope="row5">
              <div class="text-left" v-if="row5.item.freightContainerNo">
                <div v-if="row5.item.freightContainerNo">
                  <span
                    v-for="(item1, index) in row5.item.freightContainerNo.split(',')"
                    :key="index"
                  >
                    <h6>
                      <b-badge variant="light"
                        >{{ item1 == "" ? "-------" : item1 }}
                      </b-badge>
                    </h6>
                  </span>
                </div>
              </div>
              <div class="text-left" v-else>
                <b-badge variant="light">-------</b-badge>
              </div>

            
            </template>
 <template slot="freightContainersType" slot-scope="row50">
              <div v-if="row50.item.freightContainersType">
                <div v-if="row50.item.freightContainersType ">
                  <span
                    v-for="( item2, index) in row50.item.freightContainersType.split(',')"
                    :key="index"
                  >
                    <h6>
                      <b-badge variant="light"
                        >{{ item2 == "" ? "-------" : item2 }}</b-badge
                      >
                    </h6>
                  </span>
                </div>
              </div>
              <div v-else>
                <b-badge variant="light">-------</b-badge>
              </div>
             
            </template>
<template slot="shippingBillNo" slot-scope="row500">
              <div v-if="row500.item.shippingBillNo">
                <div v-if="row500.item.shippingBillNo ">
                  <span
                    v-for="( item2, index) in row500.item.shippingBillNo.split(',')"
                    :key="index"
                  >
                    <h6>
                      <b-badge variant="light"
                        >{{ item2 == "" ? "-------" : item2 }}</b-badge
                      >
                    </h6>
                  </span>
                </div>
              </div>
              <div v-else>
                <b-badge variant="light">-------</b-badge>
              </div>
             
            </template>
<template slot="shipperInvNo" slot-scope="row501">
              <div v-if="row501.item.shipperInvNo">
                <div v-if="row501.item.shipperInvNo ">
                  <span
                    v-for="( item2, index) in row501.item.shipperInvNo.split(',')"
                    :key="index"
                  >
                    <h6>
                      <b-badge variant="light"
                        >{{ item2 == "" ? "-------" : item2 }}</b-badge
                      >
                    </h6>
                  </span>
                </div>
              </div>
              <div v-else>
                <b-badge variant="light">-------</b-badge>
              </div>
             
            </template>
   <template slot="invoiceStatus" slot-scope="row33">
              <b
                :style="
                  row33.item.invoiceStatus == '0'
                    ? { color: 'green' }
                    : { color: 'red' }
                "
                >{{
                  !row33.item.invoiceStatus
                    ? "--"
                    : row33.item.invoiceStatus == "1"
                    ? "In-Progress"
                    : row33.item.invoiceStatus == "0"
                    ? "Sent To Accounts"
                    : "--"
                }}</b
              >

              <b
                v-if="
                  row33.item.sentForApproval &&
                  row33.item.sentForApproval == '1'
                "
              >
                <br />
                Sent for Approval
              </b>
              <b
                v-if="
                  row33.item.chnageApprovalStatus &&
                  row33.item.chnageApprovalStatus == '1'
                "
              >
                <br />
                Was Sent for Approval and got Approved
              </b>
              <b
                v-if="
                  row33.item.chnageApprovalStatus &&
                  row33.item.chnageApprovalStatus == '2'
                "
              >
                <br />
                Was Sent for Approval and got Rejected
              </b>
            </template>
          </b-table>
        </div>
        <h5>
          <b-row>
            <b-col md="12" class="my-1">
              <b-pagination
                limit="25"
                align="center"
                v-model="currentPage"
                :per-page="perPage"
                :total-rows="totalRows"
                @change="onPageChange($event)"
              ></b-pagination>
            </b-col>
          </b-row>
        </h5>
      </b-card-text>
    </b-card>

    <div>
      <b-modal
        size="xl"
        id="doc"
        class="modal-dialog-doc"
        no-close-on-esc
        no-close-on-backdrop
        ref="doc-modal"
        hide-footer
        title=""
      >
        <div v-if="ALLMODULE">
          <doc-form :allModuleIdProp="ALLMODULE" :JOBSERIES="JOBSERIES" />
        </div>
        <b-button
          class="mt-3"
          variant="outline-danger"
          block
          @click="hideDocModal"
          >Close
        </b-button>
      </b-modal>
    </div>

    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop"
    ></md-dialog-confirm>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import { ModelListSelect } from "vue-search-select";
import DatePicker from "vue2-datepicker";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat} from "../../helper/filters";
import { globalPermissionStatus, lastVisitPage } from "../../helper/collection";
import DocForm from "../../component/allModuleForm/docLibrary.vue";

export default {
  beforeMount() {
    lastVisitPage(this.$router.history.current.fullPath);
    if (globalPermissionStatus("Sea Freight")) {
      this.$store.dispatch(
        "setCurrentRoute",
        "/freightForward/ViewffExportFcl"
      );
      if (this.lastVisitPage && this.$sessionsStorage.get("lastVisitPage")) {
        this.fetchLastPage(this.lastVisitPage);
      } else {
        this.viewFFExportFCL("0", "0", "1", "1");
      }
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
  },

  data() {
    return {
      ALLMODULE: "",
      JOBSERIES: "",
      lastVisitPage: this.$sessionsStorage.get("lastVisitPage"),
      fields: [
        {
          key: "isFFExportActive",
          label: "Sr No.",
          sortable: true,
          sortDirection: "desc",
          class: "text-left",
        },
        {
          key: "ffExportFclSeries",
          label: "Assignment No.",
          sortable: true,
          sortDirection: "desc",
          class: "text-left",
        },

        {
          key: "clientName",
          label: "Client",
          sortable: true,
          sortDirection: "desc",
          class: "text-left colwidth",
        },

        {
          key: "freightContainerNo",
          label: "Container No.",
          sortable: true,
          sortDirection: "desc",
          class: "text-left",
        },
        {
          key: "freightContainersType",
          label: "Container Type",
          sortable: true,
          sortDirection: "desc",
          class: "text-left",
        },
        {
          key: "shippingBillNo",
          label: "Shipping Bill No.",
          sortable: true,
          sortDirection: "desc",
          class: "text-left",
        },
        {
          key: "shipperInvNo",
          label: "Shipper Invoice No.",
          sortable: true,
          sortDirection: "desc",
          class: "text-left",
        },

        {
          key: "shippingLine",
          label: "Shipping Line",
          sortable: true,
          sortDirection: "desc",
          class: "text-left",
        },
        {
          key: "invoiceStatus",
          mainkey: "invoiceStatus",
          label: "Invoice Status",
          sortable: true,
          sortDirection: "ASC",
        },
      ],

      currentPage: 1,
      perPage: 10,
      totalRows: 1000000000000000,
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      sortDirection: "desc",
      filter: null,
      modalInfo: { title: "", content: "" },

      selectedTomerge: "",
      currentPage1: 1,
      perPage1: 2,
      totalRows1: "",
      pageOptions1: [5, 10, 15],
      sortBy1: null,
      sortDesc1: false,
      sortDirection1: "desc",
      filter1: null,
      modalInfo1: { title: "", content: "" },
      filtrActive: 0,
      accounts: globalPermissionStatus("Accounts"),
      freight: globalPermissionStatus("Sea Freight"),
      routePageId: "",
      isLoading: false,
      totalCount: "",
      totalCompleted: "",
      totalVGMSubCount: "",
      totalGateInCount: "",
      totalHandoverCount: "",
      totalRailCount: "",
      totalSailCount: "",
      totalSICount: "",
      totalBLCount: "",
      bookPageId: "",
      execPageId: "",
      vgmPageId: "",
      handoverPageId: "",
      sailPageId: "",
      ladingPageId: "",
      invoiceStatusList: [
        {
          inv: "1",
          int: "In-Progress",
        },
        {
          inv: "2",
          int: "Sent to Accounts",
        },
        {
          inv: "3",
          int: "Billing Not Started",
        },
        {
          inv: "",
          int: "All",
        },
      ],
      billingFilter: "",
      alert: {
        content: "Are you sure you want to delete ..!",
        ok: "ok",
      },

      FFExport: [],
      // Modal
      mergeClickCount: "0",
      mergeModal: {
        allModuleId: "",
        splitContainerCount: "",
        splitContainer: "",
        actionType: "",
        noOfContainers: "",
        conTypeIdForEnq: "",
        conTypeForEnq: "",
        mainffId: "",
        clientId: "",
        ffExportFclId: "",
        ffExportFclIdContainer: "",
        toMergeffExecutionId: "",
        mainEnquiryId: "",
        containerTypeIdQuotation: "",
        containerTypeQuotation: "",
        toMergeEnquiryId: "",
        ffShippingWiseId: "",
      },
      actionList: [
        { aV: "1", aT: "Merge" },
        { aV: "2", aT: "Split" },
      ],
      mergeFclContainers: [],
      mergerContainerTypeQuot: [],
      containerCountType: [],
      clientList: [],
      assigmnmentList: [],
      toMergeAssignmentList: [],
      dummySplitAssignment: [],
      showAssignmentTable: false,
      asignmentSeriesCount: "",
      debounce: null,
      showContainerTable: true,
      FFExportContainers: [],
      allClientContainerData: [],
      ffAssignmentQuotation: [],
      countArry: [],
      containerList: [],
    };
  },

  mounted() {},
  filters: {
    moment(date) {
      return DateFormat(date)
    },
  },

  beforeDestroy() {},

  destroyed() {},

  components: {
    // Loading,
    CustomLoader,
    ModelListSelect,
    DocForm,
  },
  computed: {},
  watch: {
    milestoneFiltersD: {
      handler(newVal, oldVal) {},
      deep: true,
    },
  },
  methods: {
    viewExportFCLPage(item) {
      let SEEN = item.seenExec;
      let FCLID = item.ffExportFclId;

      if (SEEN != "1") {
        let paylod = {
          UpdateNotSeenToSeen: "yes",
          ffExportfclId: FCLID,
        };

        let options = {
          method: "POST",
          url: `${URL_BASE}/updateExecutionToSeenAllModules.php`,
          data: JSON.stringify(paylod),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };
        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if ( status == 200 && data) {
            }
          })
          .catch((error) => {});
      }

      this.$sessionsStorage.set("editExportFCLId", FCLID);
      this.$router.push({
        path: "/freightForward/newFFExportFcl",
      });
    },
    debounceSearch(event) {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.viewFFExportFCL("0", "0", "1", "1");

        // this.typing = null
        // this.message = event.target.value
      }, 1000);
    },
    showDocModal(item) {
      this.ALLMODULE = "";
      this.JOBSERIES = "";
      this.ALLMODULE = item.allModuleId;
      this.JOBSERIES = item.ffExportFclSeries;
      console.log(this.ALLMODULE);
      this.$refs["doc-modal"].show();
    },
    hideDocModal() {
      this.$refs["doc-modal"].hide();
    },
    fetchLastPage(event) {
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = parseInt(event) * this.perPage - this.perPage;
      }
      this.viewFFExportFCL("0", CURRENT, "2", event);
    },
    filterClear() {
      this.filter = "";
      this.viewFFExportFCL("0", "0", "1", "1");
    },
    onPageChange: function (event) {
      this.$sessionsStorage.set("lastVisitPage", event);
      this.$sessionsStorage.set(
        "oldRoute",
        this.$router.history.current.fullPath
      );
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = event * this.perPage - this.perPage;
      }

      this.viewFFExportFCL("0", CURRENT, "2", event);

      // let totalRows = 1064 / this.perPage;
      // if(this.totalRow )
    },
    goToDoc(ID) {
      this.$router.push({
        path: "/freightForwarding/ffDocListPage/" + ID + "/Export",
      });
    },

    viewFFExportFCL(filterIdD, CURRENT, SEARCH, pageNumber) {
      this.mergeFclContainers = [];
      this.containerList = [];
      this.toMergeAssignmentList = [];
      this.mergeModal.ffExportFclIdContainer = "";
      this.filtrActive = filterIdD;
      this.routePageId = filterIdD;

      this.isLoading = true;
      let payload = {
        view: "view",
        DCfilterId: filterIdD,
        searchVal: this.filter,
        DCfilterId: filterIdD,
        fromSearch: SEARCH,
        currentPage: CURRENT,
        perPage: this.perPage,
        billingFilter: this.billingFilter,
        newContainerFlow: "1",
      };
      console.log(payload);
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_FFSeaExport/ViewffExportFcl_NewV3.php`,
        data: JSON.stringify(payload),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if ( status == 200 && data) {
            this.totalRows = data.totalData;
            if (SEARCH != "2") {
              this.currentPage = 1;
              if (
                this.lastVisitPage &&
                this.$sessionsStorage.get("lastVisitPage")
              ) {
                this.currentPage = parseInt(this.lastVisitPage);
              }
            } else {
              this.currentPage = pageNumber;
            }
            if (data.ffExportDetails.length > 0) {
              this.FFExport = data.ffExportDetails;
            } else {
              this.FFExport = [];
            }

            this.isLoading = false;
          }
        })
        .catch((error) => {});
    },
  },
};
</script>
<style scoped>
.colwidth {
  min-width: 200px !important;
}
a:not(.md-button):not(.md-bottom-bar-item):hover {
  text-decoration: none !important;
}
</style>



// WEBPACK FOOTER //
// newViewffExportFcl.vue?033beb65